var map = {
	"./gallery_00.jpg": 1952,
	"./gallery_01.jpg": 1953,
	"./gallery_02.jpg": 1954,
	"./gallery_03.jpg": 1955,
	"./gallery_04.jpg": 1956,
	"./gallery_05.jpg": 1957,
	"./gallery_06.jpg": 1958,
	"./gallery_07.jpg": 1959,
	"./gallery_08.jpg": 1960,
	"./gallery_09.jpg": 1961
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1951;